<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import ContentBlocker from '#/general/ContentBlocker'
import PotentialTable from '#/detailsReport/PotentialTable'
import PotentialScoringV1 from '#/detailsReport/version1/PotentialScoringV1'
const { lead } = useDetailsReport()
</script>

<template lang="pug">
.leadAnalysisContainer
  .full-width(style="margin-bottom: 20px").row.justify-between
    .mainTitle.row.items-center Analyse
  .relative-position
    content-blocker(v-if="lead && [null, undefined].includes(lead.reasonOfInterest)")
      .blockAnalysisBtn
        div
          div Du möchtest die Analyse sehen?
          .mobileTitleTopPadding Dafür Fehlen weiter oben noch zwei klicks!
    potential-table
    potential-scoring-v1
</template>

<style scoped lang="sass">
.leadAnalysisContainer
  width: 100%
  @media screen and (min-width: 1024px)
    margin-top: 30px
  @media screen and (max-width: 1023px)
    margin-top: 50px
  .mobileTitleTopPadding
    @media screen and (max-width: 1023px)
      margin-top: 20px
  .mainTitle
    @media screen and (min-width: 1024px)
      font-weight: bold
      font-size: 30px
      line-height: 130%
      color: #22223C
    @media screen and (max-width: 1023px)
      font-weight: 700
      font-size: 20px
      line-height: 200%
      color: #2F3849
  .blockAnalysisBtn
    display: flex
    justify-content: center
    align-items: center
    font-weight: 600
    font-size: 20px
    line-height: 30px
    text-align: center
    text-transform: uppercase
    color: #FFFFFF
    padding: 20px
    background: #1F47CD
    backdrop-filter: blur(40px)
    border-radius: 10px
    box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
    @media screen and (min-width: 1024px)
      margin-top: 50px
    @media screen and (max-width: 1023px)
      margin: 100px 10px 0 10px
</style>
